export const NotFound = (): JSX.Element => {
    return (
        <div>
            404
        </div>
    );
};